import type { OptionsAPI } from './useOptions'
import AuthRegisterSection from './operation/AuthRegisterSection'
import OperationSwitchesSection from './operation/OperationSwitchesSection'
import GeneralSection from './operation/GeneralSection'
import SidebarModulesAdminSection from './operation/SidebarModulesAdminSection'
import SensitiveWordsSection from './operation/SensitiveWordsSection'
import LogSection from './operation/LogSection'
import MonitoringSection from './operation/MonitoringSection'
import CreditSection from './operation/CreditSection'
import CheckinSection from './operation/CheckinSection'

export default function OperationSetting({ options }: { options: OptionsAPI }) {
  return (
    <div>
      <AuthRegisterSection options={options} />
      <OperationSwitchesSection options={options} />
      <GeneralSection options={options} />
      <SidebarModulesAdminSection options={options} />
      <SensitiveWordsSection options={options} />
      <LogSection options={options} />
      <MonitoringSection options={options} />
      <CreditSection options={options} />
      <CheckinSection options={options} />
    </div>
  )
}
